import axiosInstance from '../../../utils/axiosConfig';

/**
 * Journey Service
 * 🗺️ Handles all API calls for financial journeys
 */
class JourneyService {
  /**
   * Get all journeys for the current user
   */
  async getAllJourneys() {
    try {
      const response = await axiosInstance.get('/api/journeys');
      return response.data;
    } catch (error) {
      console.error('Error fetching journeys:', error);
      throw error;
    }
  }

  /**
   * Get a single journey by ID
   */
  async getJourney(id) {
    try {
      const response = await axiosInstance.get(`/api/journeys/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching journey:', error);
      throw error;
    }
  }

  /**
   * Create a new journey
   */
  async createJourney(journeyData) {
    try {
      const response = await axiosInstance.post('/api/journeys', journeyData);
      return response.data;
    } catch (error) {
      console.error('Error creating journey:', error);
      throw error;
    }
  }

  /**
   * Update a journey
   */
  async updateJourney(id, journeyData) {
    try {
      const response = await axiosInstance.put(`/api/journeys/${id}`, journeyData);
      return response.data;
    } catch (error) {
      console.error('Error updating journey:', error);
      throw error;
    }
  }

  /**
   * Delete a journey
   */
  async deleteJourney(id) {
    try {
      const response = await axiosInstance.delete(`/api/journeys/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting journey:', error);
      throw error;
    }
  }

  /**
   * Generate/regenerate journey plan
   */
  async generatePlan(id) {
    try {
      const response = await axiosInstance.post(`/api/journeys/${id}/generate`, {});
      return response.data;
    } catch (error) {
      console.error('Error generating plan:', error);
      throw error;
    }
  }

  /**
   * Update journey progress
   */
  async updateProgress(id, progressData) {
    try {
      const response = await axiosInstance.post(`/api/journeys/${id}/progress`, progressData);
      return response.data;
    } catch (error) {
      console.error('Error updating progress:', error);
      throw error;
    }
  }
}

export default new JourneyService();

